import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Card, Spinner } from 'react-bootstrap';

import './styles.css';
import { getSurveyDescription } from '../../utils/surveyDescription';

const SurveyInformationCard = ({ currentSurvey, metadataDescriptions, onEditModeClick, busy }) => {
  const surveySummaryDetailsDto = useMemo(() => {
    const metaDescription = getSurveyDescription(currentSurvey, metadataDescriptions);

    if (metaDescription) {
      return metaDescription;
    }
    return {
      Data: {
        description: 'Click to add Information',
        administered: 'Click to add Information',
      },
    };
  }, [currentSurvey, metadataDescriptions]);

  return (
    <>
    
      {busy && (
        <div className="loading-container">
          <div className="content">
            <Spinner animation="border" role="status" />
            Updating preview with your changes
          </div>
        </div>
      )}
    <Card className={`survey-info-card ${busy ? 'd-none' : ''}`} onClick={onEditModeClick}>
      <Card.Header className="survey-info-card-header">Survey Information</Card.Header>
      <Card.Body>
        <h4 className="mb-2">Survey Name</h4>
        <p>{currentSurvey.title}</p>
        <h4 className="mb-2">Description</h4>
        <p>{surveySummaryDetailsDto?.Data.description}</p>
        <hr />
        <h4 className="mb-2">Time Administered</h4>
        <p>{surveySummaryDetailsDto?.Data.administered}</p>
      </Card.Body>
    </Card>
    </>
  );
};

SurveyInformationCard.propTypes = {
  currentSurvey: PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string,
    subType: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    month: PropTypes.string,
  }).isRequired,
  metadataDescriptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEditModeClick: PropTypes.func.isRequired,
};

export default SurveyInformationCard;
